import React, {Component} from 'react';
import BaseComponent, {contentParser} from "../../../base/BaseComponent";
import {Button, Input, Pagination, Tabs, Select, Modal, Tooltip, message, Menu, Dropdown, Icon} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import BaseTable from "../../components/baseTable/BaseTable";
import {formatTime} from  "../../../utils/index";
import $Jq from "jquery";

import AddModal from "./components/addModal";
import DetailsModal from "./components/detailsModal";
import {HEADER_HEIGHT} from "../../../constants";
import {permissionCheck} from "../../../utils";
import ViewTasksModal from "./components/viewTasksModal";

const { TabPane } = Tabs;
const {Search} = Input;
const { Option } = Select;

class NormalTable extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            ajaxBody: {
                num: 1,
                size: 10,
                status: '0',
                // showRef: [
                //     "taskId","appointmentId"
                // ],
            },
            total:0,//页面数据的条数
            tabData:[],
            delVisible:false,//删除弹窗
            addVisible:false,//新增弹窗,
            detailsVisible:false,//查看详情弹窗
            current:'',// 当前切换的tab
            keyword:'',
            detailsData:{},//单条数据详情页的数据
            dataId:"",//单条数据id
            id:window.top.currentUser.id,//当前的用户id
            auditOpinion:"",//审核意见
            version:"",//当条数据的字段，用来传递参数
            title:"",//当前所处的模块
            port:{
            },//模拟的接口配置项数据
            allDepartmentsData:[],//下拉菜单所有的部门
            showAddButton: false,
            dataSource:[],

        }
    }
    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({dataSource:[],keyword:''});
        this.refreshSysConfigValue(nextProps);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        $Jq('.ant-pagination-options-quick-jumper').find("input").val("");
    }
    componentWillMount() {
        let that = this;
        this.createPostMessage((e) => {
            let message = e['data']&&typeof e.data ==='string' ? JSON.parse(e['data'])['message'] : null;
            if (message == "请求刷新父页面") {
                that.getData()
            }
        }, "NormalTable")
    }
    componentWillUnmount() {
        // 销毁postMessage监听
        this.destroyPostMessage("NormalTable")
    }
    sysConfigLoadOver() {
        this.state.title = this.sysConfig.title;
        // this.state.ajaxBody = this.getAjaxBody("list");

        this.state.showAddButton = permissionCheck(this.sysConfig.addBtnAuth);
        /*this.getData();*/
        this.allDepartments();
        //tab
        let tabData = this.sysConfig.tabData || [];
        let keyArr = [];
        tabData = tabData.filter(tab=>{
            if(keyArr.indexOf(tab.key) > -1){
                return false;
            }
            if(tab.auth){
                if(!permissionCheck(tab.auth)){
                    return false;
                }
            }
            keyArr.push(tab.key);
            return true;
        });
        if(tabData.length){
            this.state.tabData = tabData;
            this.state.current=tabData[0].key;
            this.setState({},()=>{
                this.onChangeTab(tabData[0].status)
            });
        }
    }

    getAjaxBody = (type)=>{
        let res = this.sysConfig.port.find(item=>item.type === type);
        return (res && res.ajaxBody) ? JSON.parse(JSON.stringify(res.ajaxBody)) : {};
    };

    render() {

        return (
            <div style={{margin:15,background:"#fff",paddingTop:"24px",borderRadius:"5px"}}>
                {/*页面头部新增及搜索框*/}
                {this.sysConfig && !this.sysConfig.hideHeader && this.renderHeader()}
                {/*页面tab栏*/}
                {this.sysConfig && !this.sysConfig.hideTab && this.renderTab()}
                {/*页面表格*/}
                {this.renderTable()}
                {/*分页*/}
                {this.sysConfig && !this.sysConfig.hidePage && this.renderPage()}
                {/*点击删除的弹窗*/}
                {this.delModal()}
                {/*点击新增弹窗*/}
                {this.addModal()}
                {/*点击查看详情弹窗*/}
                {this.detailsModal()}
                {/*点击查看任务弹窗*/}
                {this.viewTasksModal()}
                {/*审核意见弹窗*/}
            </div>
        )
    }
    //渲染页面头部新增和搜索框
    renderHeader=()=>{
        let {allDepartmentsData} = this.state;
        return (
            <div style={{padding:"0px 32px 5px 32px"}}>
            <table border={0} cellSpacing={0} cellPadding={0} width={"100%"}><tbody><tr>
                <td width={300}>{this.state.showAddButton && <Button type={"primary"} onClick={()=>{
                    this.add.show()
                }}>新建{this.sysConfig.title}</Button>}</td>
                <td align={"right"}>
                <div>
                    <div style={{marginRight:"24px",display: "inline-block"}} className={'custom-select'}>
                        {/*判断当前页面为线索管理页面，渲染下拉框*/}
                        {this.sysConfig.showDeptSelect && permissionCheck(this.sysConfig.showDeptSelect.deptSelectAuth) && (()=>{
                            if(!this.sysConfig.showDeptSelect.tabKey){
                                return true;
                            }
                            return this.sysConfig.showDeptSelect.tabKey.indexOf(this.state.current) !== -1;
                        })() && <Select
                            allowClear
                            showSearch
                            style={{ width: 224 }}
                            placeholder="请选择提交部门"
                            onChange={(value)=>{
                                let ajaxBody = this.state.ajaxBody;
                                ajaxBody.deptId = value;
                                this.setState({ajaxBody: ajaxBody},()=>{
                                    this.getData()
                                });
                            }}
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                        >
                            {allDepartmentsData && allDepartmentsData.length && allDepartmentsData.map((item,index)=>{
                                return <Option value={item.id} key={item.id}>{item.name}</Option>
                            })}
                        </Select> }
                        {/* placeholder和光标破重叠 */}
                        <style>{`.custom-select .ant-select-selection__placeholder, .ant-select-search__field__placeholder {padding-left: 3px;}`}</style>
                    </div>
                    <Search
                        placeholder={"请输入"}
                        allowClear={true}
                        value={this.state.keyword}
                        onChange={(e)=>{
                            this.setState({keyword:e.target.value,ajaxBody:{...this.state.ajaxBody,keyword:e.target.value}})
                        }}
                        onSearch={(value)=>{this.onSearch(value)}}
                        style={{width: 272,height:32}}
                    />
                </div></td>
            </tr></tbody></table></div>
        )
    };
    //搜索按钮的回调
    onSearch = (value)=>{
        // if(value === ""){
        //     delete this.state.ajaxBody.keyword;
        //     delete this.state.ajaxBody.keywordFiled;
        // } else {
        //     this.state.ajaxBody = this.getAjaxBody("list");
        //     this.state.tabData.length&&this.state.tabData.forEach((item,index)=>{
        //         if(item.key === this.state.current){
        //             this.state.ajaxBody.params = item.param
        //         }
        //     });
        // }
        this.state.ajaxBody.keyword = value;
        this.state.ajaxBody.num = 1;
        this.state.ajaxBody.size = 10;
        this.setState({},()=>{
            this.getData()
        })
    };
    onChangeTab=(value)=>{
        this.state.ajaxBody.num = 1;
        this.state.ajaxBody.size = 10;
        this.state.ajaxBody.status = value;

        // this.state.tabData.length&&this.state.tabData.forEach((item,index)=>{
        //     if(item.key === value){
        //         this.state.ajaxBody.params = item.param
        //     }
        // });
        // this.state.current = value;
        this.setState({},()=>{
            this.getData()
        })
    };
    //渲染tab栏
    renderTab=()=>{
        return (
            <div className={"normal-tab"}>
                <Tabs activeKey={this.state.ajaxBody.status} onChange={(value)=>{
                    this.onChangeTab(value)
                }}>
                    {
                        this.state.tabData&&this.state.tabData.map((item,index) => {

                                return (
                                    <TabPane tab={item.key} key={item.status}>
                                    </TabPane>
                                )
                        })
                    }
                </Tabs>
                <style>{`
                    .normal-tab .ant-tabs-nav{margin-left: 32px}
                    .normal-tab{margin-bottom:20px}
                `}</style>
            </div>
        )
    };
    //渲染表格
    renderTable=()=>{
        const columns = this.sysConfig.columns;
        const dataSource =JSON.parse(JSON.stringify( this.state.dataSource));
        let newColumns = [];
        let that = this;
        columns&&columns.length&&columns.forEach((item,index)=>{
            let extend = item.renderComponent;
            if(extend){
                let regx = /^\$\{renderExtend\.([^.}]*)\}$/;
                if(regx.test(extend)) {
                    let renderExtendComponentName = extend.replace(regx, "$1");
                    try {
                        let RenderExtendComponent = require(`./columnRender/${renderExtendComponentName}`).default;
                        delete item.renderComponent;
                        item.render = (text, record) => <RenderExtendComponent {...item} record={record} text={text} tableComponent={that} />
                    }catch (e) {
                        console.error(e);
                    }
                }
            }
            newColumns.push(item)
        });
        dataSource.length && dataSource.forEach((item)=>{
            newColumns && newColumns.map(column=>{
                if(column.dateTime){
                    let _formatTime = formatTime;
                    try {
                        eval(`item.${column.dataIndex} = _formatTime(item.${column.dataIndex})`)
                    }catch (e) {
                        console.error(e);
                    }
                }
            });
        });
        return (
            <div style={{margin: "0 32px"}}>
                {/*autoHeight autoHeightMax={window.innerHeight - HEADER_HEIGHT - 24 - 44 - 45 - 81 - 15 - 15 - 20}*/}
                <Scrollbars autoHide autoHeight autoHeightMax={window.innerHeight - HEADER_HEIGHT  - 22 - 81 - 24 - 54-40 }>
                    <BaseTable columns={newColumns} dataSource={dataSource}/>
                </Scrollbars>
            </div>
        )
    };

    parseListBtn(record) {
        let res = [];
        if (this.sysConfig.listOpBtns) {
            contentParser(this.sysConfig.listOpBtns, {component: this});
            let btns = this.sysConfig.listOpBtns;
            for (let i = 0; btns && i < btns.length; i++) {
                let btn = btns[i];
                if(btn.extend){
                    let extend = btn.extend;
                    let regx = /^\$\{btnExtend\.([^.}]*)\}$/;
                    if(regx.test(extend)){
                        let btnExtendComponentName = extend.replace(regx, "$1");
                        try {
                            let btnExtendComponent = require(`./tableBtnExtend/${btnExtendComponentName}`).default;
                            let otherParams = btn.otherParams || {};
                            let extendObj = btnExtendComponent({component:this, record, ...otherParams});
                            if(typeof extendObj === "object"){
                                res.push(extendObj);
                            }
                        }catch (e) {
                            console.error(e);
                        }
                    }
                }else{
                    if (btn.auth) {
                        this.permissionCheck(btn.auth) && res.push(btn);
                    }else {
                        res.push(btn);
                    }
                }
            }
        }
        return res;
    }
    //查看任务
    viewTasks = (record) => {
        this.viewTasksComponent.show(record.taskId);
        this.setState({})
    };
    //查看按钮事件  误删！配置项中会动态调用
    checkDetails = (id, btnTitle, otherData = {}) => {
        this.details.show(id, otherData);
        this.setState({})
    };
    //删除按钮事件  误删！配置项中会动态调用
    delDetails = (id)=>{
        Modal.confirm({
            title: `你确定删除这条${this.sysConfig.title}吗？`,
            okText: '确认',
            cancelText: '取消',
            onOk: ()=> {
                this.handleOk(id)
            }
        });
        this.setState({dataId:id})
    };
    //编辑按钮事件  误删！配置项中会动态调用
    editDetails = (id)=>{
        this.add.show(id);
    };
    //分页栏
    renderPage=()=>{
        let {ajaxBody,total,tabData}=this.state;
        if(!total) return <div style={{height:81}}/>;
        if( ajaxBody.num>1 && total<(ajaxBody.size*(ajaxBody.num-1))) {
            ajaxBody.num = --ajaxBody.num;
            this.setState({});
            this.getData();
        }
        return(
            <div style={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                borderTop: '1px solid #eee',
                padding: '16px 32px',}}
            >
                <Pagination
                    size="middle"
                    total={total}
                    showTotal={(total) => `共${total}条`}
                    showSizeChanger
                    showQuickJumper
                    current={ajaxBody.num || 1}
                    pageSize={ajaxBody.size|| 10}
                    onChange={(e)=>{
                        ajaxBody.num = e;
                        this.setState({});
                        this.getData();
                    }} //页码改变时回调
                    onShowSizeChange={(page,size)=>{
                        ajaxBody.num = 1;
                        ajaxBody.size = size;
                        this.setState({});
                        this.getData();
                    }} //每页条数改变回调
                />
            </div>
        )
    };
    //删除按钮操作弹窗
    delModal (){
        return (
                <Modal
                    visible={this.state.delVisible}
                    title="提示"
                    onOk={()=>this.handleOk(this.state.dataId)}
                    width={400}
                    onCancel={()=>{
                        this.setState({delVisible:false})
                    }}
                    footer={[
                        <Button key="back" onClick={()=>this.setState({delVisible:false})}>
                            取消
                        </Button>,
                        <Button key="submit" type="primary" onClick={()=>this.handleOk(this.state.dataId)}>
                            确认
                        </Button>,
                    ]}
                >
                    <p>你确定删除这条{this.sysConfig.title}吗？</p>
                </Modal>
        )
    };
    //点击确认删除后的回调
    handleOk=(id)=>{
        let url = "";
        let method = "";
        let contentType = "";
        this.sysConfig.port.forEach((item)=>{
            if(item.type  === "delete"){
                url = ""+item.url+id;
                method = item.method;
                contentType = item.contentType;
            }
        this.request({
            url: url,
            method:method,
            contentType: contentType,
            body: "",
            callBack: (res) => {
                if(res){
                    message.destroy();
                    message.success("删除成功");
                    this.setState({delVisible:false,dataId:""},()=>{
                        this.getData()
                    })
                }
            },
            errorCallBack: (e) => {
            },
        })
        })
    };
    onCancel=()=>{
        this.setState({addVisible:false})
    }

    //点击新增的弹窗
    addModal=()=>{
        let sysConfigData = this.sysConfig;
        let props={
            pageType:this.sysConfig.title,
            title:"新建"+this.sysConfig.title,
            sysConfigData:sysConfigData,
            pageName:this.sysConfig.title,
            allDepartmentsData:this.state.allDepartmentsData,
            pojoName: this.sysConfig.pojoName, // 后端存储数据的表名
            activitiConfName: this.sysConfig.activitiConfName, // 流程图识别码
        };
        return JSON.stringify(sysConfigData) === "{}" ? <></> : (
            <AddModal
                {...props}
                ref={(add) => {
                    this.add = add
                }}
                callBack={() => {
                    this.getData()
                }}
            />
        )
    };
    //详情页面弹窗
    detailsModal=()=>{
        let sysConfigData = this.sysConfig;
        let props={

            title:"新增"+this.sysConfig.title,
            details:this.sysConfig.detailTitle || this.sysConfig.title+"详情",
            sysConfigData:sysConfigData,
            detailsData:this.state.detailsData,
            pojoName: this.sysConfig.pojoName, // 后端存储数据的表名
            activitiConfName: this.sysConfig.activitiConfName, // 流程图识别码
        };
        return JSON.stringify(sysConfigData) === "{}" ? <></> : (
            <DetailsModal {...props} ref={(details)=>{this.details=details}} callBack={()=>{
               this.getData()
            }}/>
        )
    };
    //查看任务页面弹窗
    viewTasksModal = () => {
        let sysConfigData = this.sysConfig;
        let props = {
            title: "任务详情",
            // details: this.sysConfig.detailTitle || this.sysConfig.title + "详情",
            // sysConfigData: sysConfigData,
            // detailsData: this.state.detailsData,
            // pojoName: this.sysConfig.pojoName, // 后端存储数据的表名
            // activitiConfName: this.sysConfig.activitiConfName, // 流程图识别码
        };
        return JSON.stringify(sysConfigData) === "{}" ? <></> : (
            <ViewTasksModal {...props} ref={(viewTasksModal) => {
                this.viewTasksComponent = viewTasksModal
            }}/>
        )
    };
    //页面数据接口(含查询接口)
    getData = () => {
        let url = "";
        let method = "";
        let contentType = "";
        this.sysConfig.port.forEach((item)=>{
            if(item.type  === "list"){
                url = item.url;
                method = item.method;
                contentType = item.contentType;
            }
        });
        let {ajaxBody} = this.state;

        this.request({
            url: url,
            method:method,
            contentType: contentType,
            body: ajaxBody,
            callBack: (res) => {
                if(res){
                    this.setState({dataSource:res.data,total:res.count})
                }
            },
            errorCallBack: (e) => {
            },
        })

    }
    //获取当前所有部门
    allDepartments = ()=>{
        this.request({
            url: "/cm-sites-sys/dept/getAll",
            method:"GET",
            callBack: (res) => {
                this.setState({allDepartmentsData:res})
            },
            errorCallBack: (e) => {
            },
        })
    }

    //修改状态
    updateStatus = (id, status, version, msg,item,record) => {
        // 取接口参数
        let url = "";
        let method = "";
        let contentType = "";
        // window.loading.show();
        this.sysConfig.port.forEach((item) => {
            if (item.type === "update") {
                url = item.url;
                method = item.method;
                contentType = item.contentType;
            }
        });
        if (!url || !method || !contentType) {
            // window.loading.hide();
            return false;
        }

        if(item.newTimeCheck){
            //当前时间去掉秒
            let currentTime = formatTime(new Date());
            let date = new Date(currentTime);
            let newData = date.getTime();
            //回稿时间
            let replyDate = new Date(record.replyDate);
            replyDate = replyDate.getTime();
            if(replyDate < newData){
                message.destroy();
                message.warning(item.checkMessage);
                // window.loading.hide();
                return false
            }
        }
        let params = {id,status,version};
        let that = this;
        this.request({
            url:url+id,
            method: method,
            contentType: contentType,
            body: params,
            callBack: function (res) {
                message.destroy();
                message.success(msg);
                that.getData();
            },
            errorCallBack: function (e) {
                console.log(e.toString());
            }
        })
    };
}

export default NormalTable;
